export const environment = {
	production: true,
	payPalClientId: 'AaDV7OzTWSCE51DQXRmVGs2jfz1gep6L8oCvwQbyYevq3zHkfiKcAYKaYD4LYj_VcW_8dV6nNO5nkYa0',
	stripePK: 'pk_live_41SVSiIEMin8o0FSb7HfASGTLOgRqQbEGsC6SWLc9ag3c4zuH3jWqtj40pV3lyAa4O7De3Hv5UQeHhQjggWHr5w8000HVyknWj5',
	urlOverride: false,
	frontPluginHost: 'https://front.writtenwordmedia.com',
};
